/**
 * ProductsOverviewHeader – KPI-Karten für /v2/products.
 * Die Sync-Statuszeile wird in Products.tsx mit echten Daten komponiert.
 */
import type { NavigateFunction } from 'react-router-dom'
import type { ProductKpiSummary } from '@/lib/api/products-kpi'
import { ProductKpiCards } from './ProductKpiCards'

interface ProductsOverviewHeaderProps {
  kpi: ProductKpiSummary | null
  onNavigate: NavigateFunction
}

export function ProductsOverviewHeader({ kpi, onNavigate }: ProductsOverviewHeaderProps) {
  return (
    <ProductKpiCards
      kpi={kpi}
      issuesCount={kpi?.with_issues_count ?? 0}
      onFixIssues={() => onNavigate('/v2/products/issues')}
      onAutoGenerate={() => onNavigate('/v2/products?segment=ohne-packshot')}
    />
  )
}
